"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var updateFavoritesUserOption_1 = require("./updateFavoritesUserOption");
var datapoints_1 = require("../datapoints");
var owa_mail_favorites_store_1 = require("owa-mail-favorites-store");
var legacy_1 = require("satcheljs/lib/legacy");
/**
 * Remove a favorite category from the favorite store
 * @param id of the category
 * @param actionSource where the remove favorite category comes from
 */
exports.default = legacy_1.action('removeFavoriteCategory', datapoints_1.default.RemoveFavoriteCategory)(function removeFavoriteCategory(id, actionSource) {
    // Check if favoriteCategories doesn't contain the category
    if (!owa_mail_favorites_store_1.favoritesStore.favoriteCategories.has(id)) {
        throw new Error('Cannot find the category in favorite category list.');
    }
    // Remove favorite from the store
    owa_mail_favorites_store_1.favoritesStore.orderedFavoritesNodeIds.splice(owa_mail_favorites_store_1.favoritesStore.orderedFavoritesNodeIds.indexOf(id), 1);
    owa_mail_favorites_store_1.favoritesStore.favoriteCategories.delete(id);
    // Update user options service which is used by OWA
    updateFavoritesUserOption_1.default();
});
//# sourceMappingURL=removeFavoriteCategory.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-favorites-store/lib/actions/removeFavoriteCategory.js
// module id = 4655
// module chunks = 14